module.exports = __webpack_public_path__ + "static/img/icon-4.54f161c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-3/icon-4.png
// module id = PPOu
// module chunks = 0